import enUS from './en-US';
// 隐藏国际化
import zhCN from './zh-CN';
export interface LangConf {
  locale: string;
  desc: string;
  [key: string]: string;
}

export interface LangMap {
  [key: string]: LangConf;
}

const langMap: LangMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

export default langMap;
